import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import colors from "glesys-controlpanel/helpers/colors";

<template>
  <span class="text-xs px-1 leading-none py-1 rounded-sm {{colors 'green'}}" {{mergeClasses}} ...attributes>
    {{@text}}
  </span>
</template>
